<template>
  <div>
    <v-textarea
      v-model="instructions"
      label="Instructions Document"
    >

    </v-textarea>
    <v-btn success @click.native="saveInstructions()">Save</v-btn>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    data () {
      return {
        instructions: ''
      }
    },
    created () {
      this.fetchConfig().then(() => {
        this.instructions = this.config.instructionsDocument
      })
    },

    computed: {
      ...mapGetters('returnShopPortal', [
        'configActivated'
      ]),
      ...mapState('returnShopPortal', [
        'config'
      ])
    },

    methods: {
      ...mapActions('returnShopPortal', [
        'fetchConfig',
        'saveConfig'
      ]),

      saveInstructions () {
        const config = this.config
        config.instructionsDocument = this.instructions
        this.saveConfig(config)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ReturnShopPortalsInstructionsDocument.vue?e55e185a